// in dev, this makes Vite inject its client as this module's first dependency,
// so that global constant replacements are installed before any other module
// (including user hooks) evaluates. In build it's inert.
import.meta.hot;

import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16')
];

export const server_loads = [];

export const dictionary = {
		"/(webapp)/[[locale=locale]]/account": [5,[2]],
		"/api": [16],
		"/(webapp)/[[locale=locale]]/app": [6,[2]],
		"/(webapp)/blog": [11,[2]],
		"/(webapp)/blog/posts/how-to-align-vocals": [12,[2]],
		"/(webapp)/[[locale=locale]]/checkout/success": [7,[2]],
		"/(webapp)/[[locale=locale]]/download": [8,[2]],
		"/(webapp)/impressum": [13,[2]],
		"/[[locale=locale]]/plugin": [15,[3]],
		"/(webapp)/[[locale=locale]]/plugin/login": [9,[2]],
		"/(webapp)/privacy": [14,[2]],
		"/(webapp)/[[locale=locale]]/results": [~10,[2]],
		"/(webapp)/[[locale=locale]]": [4,[2]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);